import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';
@Injectable()
export class HaLicenseServiceService {

  constructor(private http: HttpClient) { }

  getLicenseList(pageNo, searchText, licenseFilter) {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/LicenseManagement/getLicenses?pageNo='+pageNo+'&searchText='+searchText+'&licenseFilter='+licenseFilter);
  }


  blockActiveLicense(saHospId) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/LicenseManagement/blockActiveLicense', { id: saHospId });
  }

  getUsersUnderLicense(saHospId) {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/LicenseManagement/getUsersUnderLicense?eaHospId='+saHospId);
  }

  blockActiveUser(saHospId) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/LicenseManagement/blockActiveUser', { id: saHospId });
  }

}
